// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"83571726","753":"5382358e"}[chunkId] + ".chunk.css";
};